var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirehydrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FireHydrant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E85D2D",
    d: "M12 2c-1.2 2.4-3.6 3.6-3.6 6.6a3.6 3.6 0 107.2 0C15.6 5.6 13.2 4.4 12 2zm0 14.4a4.8 4.8 0 01-4.8-4.8h1.8a3 3 0 006 0h1.8a4.8 4.8 0 01-4.8 4.8z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#E85D2D",
    x: 10.2,
    y: 17.4,
    width: 3.6,
    height: 4.2,
    rx: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirehydrant);
export default __webpack_public_path__ + "static/media/firehydrant.d9c10f03.svg";
export { ForwardRef as ReactComponent };